<script setup lang="ts" generic="T extends AnyItem = AnyItem">
import type { AnyItem } from '#layers/data-model/public';
import type { RenderDisplayTemplateProps } from './RenderDisplayTemplate.vue';
import { reactiveOmit } from '@vueuse/core';
import { computed } from 'vue';
import { isEmptyDisplayTemplate, useCollection, useCollectionDisplayTemplate } from '#layers/data-model/public';

const props = defineProps<RenderDisplayTemplateProps<T>>();

const forwarded = reactiveOmit<RenderDisplayTemplateProps<T>, 'displayTemplate'>(props, 'displayTemplate');

const { collection } = useCollection(() => props.collectionId);
const collectionDisplayTemplate = useCollectionDisplayTemplate(() => collection.value!); // we can safely unwrap here because we check for a collection before rendering the display template
const displayTemplate = computed(() => isEmptyDisplayTemplate(props.displayTemplate) ? collectionDisplayTemplate.value : props.displayTemplate);
</script>

<template>
	<DisplayTemplateConfigurationError v-if="!collection" :error="$t('display_template.missing_collection')" />
	<RenderDisplayTemplate v-else v-bind="forwarded" :display-template />
</template>
